import { SxProps } from "@mui/system";
import { Controller, useFormContext } from "react-hook-form";
import WorkTitleAutocomplete from "./workTitleAutocomplete/WorkTitleAutocomplete";

type Props = {
  name: string;
  fullWidth?: boolean;
  isLoading?: boolean;
  groupByFieldOfWork?: boolean;
  multiple?: boolean;
  limitTags?: number;
  inputSx?: SxProps;
  fetchAll?: boolean;
  disabled?: boolean;
  placeholder?: string;
};

const WorkTitleAutocompleteField = ({
  name,
  fullWidth,
  isLoading = false,
  groupByFieldOfWork = true,
  multiple = true,
  limitTags,
  inputSx = {},
  fetchAll = false,
  disabled = false,
  placeholder,
}: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      // TODO: RULES
      control={control}
      render={({ field: { value, onChange } }) => (
        <WorkTitleAutocomplete
          value={Array.isArray(value) ? value : undefined}
          onChange={(newValue) => onChange(newValue)}
          multiple={multiple}
          fullWidth={fullWidth}
          disabled={isLoading || disabled}
          groupByFieldOfWork={groupByFieldOfWork}
          limitTags={limitTags}
          fetchAll={fetchAll}
          placeholder={placeholder}
          sx={inputSx}
        />
      )}
    />
  );
};

export default WorkTitleAutocompleteField;
